import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { getPropsFromMeta } from "../../utils"
import CompMeta from '../../meta/LowCodeComponents/CardTable';

/**
 * @class NCCardTable
 * @column 1
 * @compType 1
 * @canAppend false
 * @path LowCodeComponents.NCCardTable
 * @label 多页签表格
 *
 */
class NCCardTable extends Component {
    static propTypes = {
        /**
         * @title 区域编码
         * @description 区域编码
         */
        moduleId: PropTypes.string.isRequired,
        /**
         * @title 显示序号
         * @description 显示序号
         */
        showIndex: PropTypes.bool,
        /**
         * @title 显示复选框
         * @description 显示复选框
         */
        showCheck: PropTypes.bool,
        /**
         * @title 是否滚动加载
         * @description 是否滚动加载
         */
        height: PropTypes.number,
        /**
         * @title 是否滚动加载
         * @description 是否滚动加载
         */
        lazyload: PropTypes.bool,
        /**
         * @title 是否自适应高度
         * @description 是否自适应高度
         */
        adaptionHeight: PropTypes.bool,
        /**
         * @title 最后一行录入数据自动增行
         * @description 最后一行录入数据自动增行
         */
        isAddRow: PropTypes.bool,
        /**
         * @title 是否显示多行
         * @description 是否显示多行
         */
        multipleRowCell: PropTypes.bool,
        /**
          * @title 行样式
          * @description 行样式
          */
        rowClassList: PropTypes.string,
        /**
         * @title 整单保存按钮显隐
         * @description 整单保存按钮显隐
         */
        hideModelSave: PropTypes.bool,
        /**
         * @title 侧拉增行按钮显隐
         * @description 侧拉增行按钮显隐
         */
        hideAdd: PropTypes.bool,
        /**
         * @title 侧拉删行按钮显隐
         * @description 侧拉删行按钮显隐
         */
        hideDel: PropTypes.bool,
        /**
         * @title 孙表的id
         * @description 孙表的id
         */
        grandTableId: PropTypes.string,
        /**
         * @title 子孙关系code
         * @description 子孙关系code
         */
        pkcode: PropTypes.string,
        /**
         * @title 是否在弹窗内
         * @description 是否在弹窗内
         */
        inModal: PropTypes.bool,
        /**
         * @title 表头按钮区
         * @description 表头按钮区
         */
        tableHeadRight: PropTypes.node,
        /**
        * @title 表头左侧区域
        * @description 表头左侧区域
        */
        tableHeadLeft: PropTypes.node,
        /**
      * @title 是否可见
      * @description 是否可见
      */
        visible: PropTypes.bool,

    }
    static defaultProps = {
        showIndex: false,
        showCheck: true,
        lazyload: true,
        adaptionHeight: true,
        isAddRow: false,
        inModal: false
    }
    static getCompMeta() {
        return CompMeta;
    }

    renderComp() {
        const { cardTable, moduleId, meta, config = {} } = this.props;
        const { createCardTable } = cardTable;
        const configProps = getPropsFromMeta(this.props, NCCardTable.getCompMeta());
        const { tableHeadLeft, tableHeadRight } = configProps;
        //转换cardtable对应的插槽函数
        if (tableHeadLeft) {
            if (config.multiConfig) {
                for (let key of Object.keys(config.multiConfig)) {
                    if (!config.multiConfig[key].tableHeadLeft) {
                        config.multiConfig[key].tableHeadLeft = () => tableHeadLeft;
                    }
                }
            } else {
                if (!config.tableHeadLeft) {
                    config.tableHeadLeft = () => tableHeadLeft;
                }
            }
        }
        if (tableHeadRight) {
            //configProps.tableHead = () => tableHeadRight;
            if (config.multiConfig) {
                for (let key of Object.keys(config.multiConfig)) {
                    if (!config.multiConfig[key].tableHead) {
                        config.multiConfig[key].tableHead = () => tableHeadRight;
                    }
                }
            } else {
                if (!config.tableHead) {
                    config.tableHead = () => tableHeadRight;
                }
            }
        }

        let metaData = meta.getMeta();
        let ret = null;
        let tableMetaData = metaData[moduleId];
        if (tableMetaData) {
            ret = (
                <div className="nc-bill-tableTab-area">
                    {createCardTable(moduleId, Object.assign(configProps, config))}
                </div>
            )
        } else {
            ret = (
                <div>没有绑定模板数据</div>
            )
        }
        return ret;

    }

    render() {
        return (
            <React.Fragment>
                {this.renderComp()}
            </React.Fragment>
        )
    }
}

export default NCCardTable;
